
import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import moment from 'moment';
import DateRangePicker from '@/features/common/components/DateRangePicker.vue';

@Component({
  components: {
    DateRangePicker,
  },
})
export default class DateRangePickerInput extends Vue {
  @Prop({ required: false, default: false }) disabled!: boolean;

  @Prop({ required: false, default: true }) futureDateEnabled!: boolean;

  @Prop({ required: false, default: false }) enforceRangeOrder!: boolean;

  @PropSync('dateRangeInput', { required: true }) dateRangeInputSync!: string;

  @PropSync('dateCalendar', { required: true }) dateCalendarSync!: string[];

  private isShowDateRangePicker = false;

  private async applyDateRangeFilter(calendarData: string[]): Promise<void> {
    this.dateCalendarSync = calendarData;
    await this.formatDateRangeInput();
    this.closeDateRangePicker();
    this.$emit('onApplyFilter', calendarData);
  }

  private async formatDateRangeInput() {
    await this.$nextTick();
    this.dateRangeInputSync = this.dateCalendarSync.map(
      (date) => moment(date, 'YYYY-MM-DD').format('MMM D, YYYY'),
    ).join(' - ');
  }

  private async clearDateRangeFilter(): Promise<void> {
    this.dateRangeInputSync = '';
    this.dateCalendarSync = [];
    this.applyDateRangeFilter([]);
  }

  private closeDateRangePicker() {
    this.isShowDateRangePicker = false;
    this.$emit('onCloseFilter');
  }
}
